import { type ShapeProps } from './Ripple'

export const CircleShape = (props: ShapeProps) => {
  const { rootRef, ...rest } = props
  return (
    <svg viewBox="0 0 100 100" ref={rootRef} {...rest}>
      <circle cx="50" cy="50" r="50" />
    </svg>
  )
}
